import { randomId } from '@composables/utils/guid.js'
import { log, getGlobalCtx } from '@composables/utils/logger'
import { datadogLogs } from '@datadog/browser-logs'
import { datadogRum } from '@datadog/browser-rum'
import { getInstallationId } from '@composables/utils/sessionIdUtils'

const env = import.meta.env.VITE_APP_ENVIRONMENT
const clientToken = import.meta.env.VITE_DATADOG_CLIENT_TOKEN
const version = import.meta.env.VITE_APP_VERSION
const service = `tb-onboarding-web-${env}`
const sessionId = randomId()
log.bind({ session_id: sessionId })
log.bind({ installation_id: getInstallationId() })

if (clientToken != null) {
  datadogLogs.init({
    clientToken,
    site: 'datadoghq.com',
    service,
    env,
    version,
    forwardErrorsToLogs: true,
    forwardConsoleLogs: 'all',
    sessionSampleRate: 100
  })
}

if (clientToken != null && env === 'prod') {
  datadogRum.init({
    applicationId: '8d96e7b9-077d-4394-907d-f96b6e4bf246',
    clientToken,
    site: 'datadoghq.com',
    service,
    env,
    version,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 50,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    storeContextsAcrossPages: true,
    defaultPrivacyLevel: 'mask-user-input',
    enableExperimentalFeatures: ['feature_flags'],
    allowedTracingUrls: [(url) => url.includes('transferbank.com.br')]
  })

  datadogRum.setGlobalContextProperty('session_id', getGlobalCtx().session_id)
  datadogRum.setGlobalContextProperty('installation_id', getGlobalCtx().installation_id)

  datadogRum.onReady(() => {
    const internalContext = datadogRum.getInternalContext()
    log.bind({ dd_session_id: internalContext.session_id })
  })
}
